import { RECEIVED_HOUSEHOLD_INFORMATION } from './HouseholdInformationActions';

export const householdInformationInitialState = {};

export const householdInformationReducer = (
  state = householdInformationInitialState,
  action
) => {
  if (action.type === RECEIVED_HOUSEHOLD_INFORMATION) {
    const { householdBalanceTierStatus, householdMembers } = action.payload;

    if (!action.payload || !householdBalanceTierStatus) {
      return state;
    }

    const {
      balanceReportDate,
      totalAssetBalanceAmount,
      householdAssetTier,
      nextHouseholdAssetTier
    } = householdBalanceTierStatus;

    const { maximumAmount, id, kiplingerAccess, morningstarPremiumAccess } =
      householdAssetTier;

    return {
      assetBalance: totalAssetBalanceAmount,
      assetId: id,
      balanceReportDate,
      householdMembers,
      nextTierAssetId: nextHouseholdAssetTier.id,
      tierMaximum: maximumAmount,
      kiplingerAccess,
      morningstarAccess: morningstarPremiumAccess
    };
  }
  return state;
};
